module.exports = __webpack_public_path__ + "d4f4efa76b716d866113bc613da96b1d.MP3";